import { z } from 'zod'

import { bookingSchema, orderCompletePaymentArgsSchema } from './booking'
import { orderCartCreateArgsSchema, orderCartSchema } from './orderCart'

export const inPersonGuestSchema = z.object({
  name: z.string().trim().min(1).optional(),
  email: z.string().trim().email().optional(),
  phone: z.string().trim().min(1).optional(),
})

export const inPersonCartCreateArgsSchema = orderCartCreateArgsSchema.extend({
  guest: inPersonGuestSchema.optional(),
})

export const inPersonOrderCreateArgsSchema = z.object({
  cartId: z.string(),
  orderId: z.string().optional(),
  client: z.string().optional(),
  attributionId: z.string().optional(),
  items: z
    .array(
      z.object({
        inventoryId: z.string(),
        arrivalTime: z.coerce.date().nullish(),
        guests: z.number().int().min(1).nullish(),
      })
    )
    .optional(),
  name: z.string().optional(),
  arrivalTime: z.coerce.date().optional(),
  userNotes: z.string().optional(),
  customerMarketingOptIn: z.boolean().optional(),
  customerMarketingOptInSignature: z.string().optional(),
  guest: inPersonGuestSchema.optional(),
})

export const inPersonOrderCreateResponseSchema = z.object({
  order: bookingSchema,
})

export const inPersonCompletePaymentArgsSchema = orderCompletePaymentArgsSchema

export const inPersonCartResponseSchema = orderCartSchema
